import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/varano-construction/varano-construction/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/varano-construction/varano-construction/components/ThemeColor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveSiteConfigProvider"] */ "/home/runner/work/varano-construction/varano-construction/lib/SiteConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/varano-construction/varano-construction/node_modules/next/dist/client/app-dir/link.js");
